import {
  Layout,
  Input,
  Avatar,
  Badge,
  Space,
  Typography,
  Row,
  Col,
  Dropdown,
} from "antd";
import {
  UserOutlined,
  BellFilled,
  SearchOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  setIsloggedIn,
  setRole,
  setUserId,
} from "../../redux/feature/auth/auth";
import msalInstance from "../../aad/azureAAD";
import React, { useEffect, useState } from "react";
import { postAPI, getAPI } from "../../config/api/apiConfig";


const { Header } = Layout;


// const items = [
//   {
//     key: "1",
//     label: "Software Engineer",
//   },
//   {
//     key: "2",
//     label: "Log Out",
//   },
// ];

const DashboardHeader = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [userOrganisation, setUserOrganisation] = useState(null);
  const [username, setUsername] = useState(null);


  const organisationName = useSelector(
    (state) => state.authenticate.organisationName
  );
  const userId = useSelector((state) => state.authenticate.userId);


  useEffect(() => {
    // console.log("Fetching organisation data for userId:", userId);
    getAPI(`/get-organisation-by-user/${userId}`)
      .then((response) => {
        // console.log("API Response: ", response);
        const { data } = response.data;
        setUserOrganisation(data.organisationName);
        setUsername(data.username);
        // console.log("Organisation data set successfully:", data);
        // form.setFieldsValue({
        //   organisationName: data.organisationName,
        // });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [userId]);

  const handleMenuClick = (e) => {
    if (e.key === "2") {
      dispatch(setIsloggedIn(false));
      dispatch(setRole(""));
      dispatch(setUserId(""));
      localStorage.removeItem("activeTab");
      localStorage.removeItem("persist:authenticate");
      localStorage.removeItem("persist:device");
      history.push("/sign-in");
      msalInstance.logoutRedirect();
      localStorage.setItem("isAuthenticated", JSON.stringify(false));
    }
  };

  const items = [
    {
      key: "1",
      label: username || "Loading...", // Use the username state variable
    },
    {
      key: "2",
      label: "Log Out",
    },
  ];

  return (
    <Header className="dashboard-header header">
      {/* <div className="logo" /> */}
      <Space direction="horizontal">
        {" "}
        <Col xs={24} sm={12} md={12} lg={12} xl={8}>
          <Input
            placeholder="Search..."
            allowClear
            // onSearch={onSearch}
            className="search-bar"
            style={{
              width: 400,
              minWidth: 200,
              padding: 0,
              marginLeft: "15%",
              borderRadius: 15,
            }}
            prefix={
              <SearchOutlined style={{ paddingLeft: 10, paddingRight: 10 }} />
            }
          />
        </Col>
      </Space>
      
        <Col></Col>
        <div className="user-profile" >
        <Col xs={2} md={2} sm={2} lg={2} xl={2} >
         
          <Badge className="space" style={{marginTop: 25, width: 20,  height: 20, textAlign:'center', borderRadius: '50%' }} count={null}>
            <BellFilled  style={{ fontSize: "27px", color: '#5B7B68', marginTop: 20, }} />
          </Badge>
        </Col>
        <Col xs={2} md={1} sm={1} lg={2} xl={2}>
          <Avatar style={{ backgroundColor: '#5B7B68', color: '#F0EFE9', marginleft: 40 }} size={30} icon={<UserOutlined style={{ fontSize: "18px" }}/>} />
        </Col>
        <Col >
          <Space>
            <Dropdown
            className="drop"

              menu={{
                items,
                selectable: true,
                onClick: handleMenuClick,
              }}
            >
              <Typography.Link>
                <Space>
                  <span
                    className="username"
                    style={{ color: "#000", fontSize: "0.8em" }}
                  >
                    {/* {organisationName} */}
                    {userOrganisation}
                  </span>
                  <CaretDownOutlined />
                </Space>
              </Typography.Link>
            </Dropdown>
          </Space>
          
        </Col>
        </div>
      
    </Header>
  );
};

export default DashboardHeader;

